import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { disconnectUserWithPatron } from "api/services/user-service";

export const useDisconnectUserWithPatron = () => {
    const { callAPI, loading } = useWorkspaceApiCall(disconnectUserWithPatron, '', 'disconnectUserWithPatron.error');    

    return { disconnectUserWithPatron: callAPI, disconnectingWithPatron: loading };
}